import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import WarehouseMap from "../../../classes/WarehouseMap";

export default {
  routes: [
    {
      name: "warehouse-maps",
      path: "warehouse-maps/:filter?",
      meta: {
        auth: () => WarehouseMap.canBeViewedBy(store.state.main.user),
        icon: "warehouse",
        title: i18n.global.tc("Warehouse Map", 100),
        crumbs: ["admin"],
        color: "admin",
      },
      component: () => import("pages/admin/WarehouseMaps"),
    },
    {
      name: "warehouse-map",
      path: "warehouse-maps/:warehouse/map",
      meta: {
        auth: () => WarehouseMap.canBeViewedBy(store.state.main.user),
        icon: "map",
        title: (route) => route.params.warehouse,
        crumbs: ["admin", "warehouse-maps"],
        color: "admin",
        hideFromIndex: true,
      },
      component: () => import("pages/admin/WarehouseMapCanvas"),
    },
  ],

  dialogs: [
    {
      name: "warehouse-maps-reorder",
      path: "/admin/warehouse-maps/reorder",
      meta: {
        auth: () => WarehouseMap.canBeEditedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/WarehouseMapsReorder"),
    },
  ],
};
